export default "<p>admin-survey-list works!</p>\n"